import { ModuleAdminPage } from "./ModuleAdminPage";
export function AdminGemsPage() { return <ModuleAdminPage title="寶石碎片" code="gems" text="管理寶石來源、兌換表與 V2 預留兌換開關。" />; }
